var _SocialLink, _SocialLink2, _SocialLink3, _SocialLink4, _SocialLink5;
import { Facebook, Instagram, Linkedin, Twitter, Youtube } from "@crehana/icons";
import { Col, Row } from "@crehana/ui";
import LazyLoad from "../../../Lazyload";
import Loadable from "../../../Loadable";
import AppsColumn from "../../components/AppsColumn";
import CurrencyLoader from "../../components/CurrencyLoader";
import Copyright from "./Copyright";
import SocialLink from "./SocialLink";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var BottomSection = function BottomSection(_ref) {
  var isDark = _ref.isDark;
  return /*#__PURE__*/_jsxs(Row, {
    className: "flex items-center pb-32 sm:pb-48 lg:pb-64 md:items-end lg:items-center",
    children: [/*#__PURE__*/_jsx(Copyright, {
      isDark: isDark,
      className: "hidden md:block"
    }), /*#__PURE__*/_jsx(AppsColumn, {
      isDark: isDark,
      className: "flex flex-col items-center mb-24 md:hidden sm:mb-0 sm:items-start"
    }), /*#__PURE__*/_jsxs(Col, {
      sm: 5,
      md: 4,
      lg: 6,
      offset: {
        sm: 1,
        md: 0
      },
      nowrap: true,
      className: "flex flex-col items-center self-end justify-end sm:items-start md:items-end lg:items-center lg:flex-row",
      children: [/*#__PURE__*/_jsxs("span", {
        className: "md:mr-12 mb-24 sm:mb-32 md:mb-24 lg:mb-0 flex ".concat(isDark ? 'text-white' : 'text-gray-dark'),
        children: [_SocialLink || (_SocialLink = /*#__PURE__*/_jsx(SocialLink, {
          link: "https://www.facebook.com/Crehanacom/",
          icon: Facebook
        })), _SocialLink2 || (_SocialLink2 = /*#__PURE__*/_jsx(SocialLink, {
          link: "https://twitter.com/crehanacom",
          icon: Twitter
        })), _SocialLink3 || (_SocialLink3 = /*#__PURE__*/_jsx(SocialLink, {
          link: "https://www.instagram.com/crehanacom/",
          icon: Instagram
        })), _SocialLink4 || (_SocialLink4 = /*#__PURE__*/_jsx(SocialLink, {
          link: "https://www.linkedin.com/school/crehana/",
          icon: Linkedin
        })), _SocialLink5 || (_SocialLink5 = /*#__PURE__*/_jsx(SocialLink, {
          link: "https://www.youtube.com/channel/UCg6_yPdtalblZ0Peqjv5rPg/featured",
          icon: Youtube
        }))]
      }), /*#__PURE__*/_jsx(LazyLoad, {
        children: /*#__PURE__*/_jsx(Loadable, {
          module: function module() {
            return import( /* webpackChunkName: "main-footer-currency-dropdown"  */"../../components/CurrencyDropdownSelector");
          },
          Loader: /*#__PURE__*/_jsx(CurrencyLoader, {
            isDark: isDark
          }),
          isDark: isDark
        })
      })]
    }), /*#__PURE__*/_jsx(Copyright, {
      isDark: isDark,
      className: "md:hidden"
    })]
  });
};
export default BottomSection;